import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {keyframes} from '@emotion/core';

const scaleDam = keyframes`
    100% {
      transform: scale(0.5);
      opacity: 0.5;
    }
  `;

const Icon = styled.svg`
  .st0 {
    opacity: 0.21;
    fill: #ffffff;
    transform-origin: bottom;

    .active,
    .idle & {
      animation: ${scaleDam} 5s cubic-bezier(0.4, 0, 1, 1) infinite alternate;
    }
  }
  .st1 {
    fill: none;
    stroke: #ffffff;
    stroke-width: 2;
  }
`;
export const DamsIcon = () => {
  return (
    <Icon viewBox='0 0 90.2 72.4'>
      <g id='dam_icon' data-name='dam icon'>
        <polygon
          className='st0'
          points='45.1,70.8 78.6,16.8 45.1,16.8 11.7,16.8'
        />
        <polyline
          id='Path-9'
          className='st1'
          points='0.9,0.5 44.8,70.5 89.3,0.5'
        />
        <line className='st1' x1='11.7' y1='16.8' x2='78.6' y2='16.8' />
      </g>
    </Icon>
  );
};

DamsIcon.propTypes = {
  state: PropTypes.string,
};
